module.exports = __webpack_public_path__ + "img/banner0-back.b93ca92c.png";